module Meevo.Plugins.ClientApp {
    "use strict";

    const MAXSAFEINTEGER = 2147483647;

    export class PackageMenuConfigSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        public customButtonsSet: any;
        public packages: any;
        public copy: any;
        public auditNoun: Meevo.Model.NounEnum;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected basedataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            private $filter: angular.IFilterService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            sectionSecurityKey?: string,
            protected context?: Meevo.Plugins.ClientApp.ClientAppContext) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
            this.basedataService = basedataService;
            this.initializeData();
        }

        initializeData(): void {
            this.auditNoun = Meevo.Model.NounEnum.ClientAppPackageMenu;
            this.getPackages();
            this.context.setMode(Model.MaintenanceFormState.Readonly);
            this.mode = Model.MaintenanceFormState.Readonly;

            var scope = this;
            this.customButtonsSet = [
                {
                    text: 'LABEL_EDIT',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppPackageMenuTab, Model.VerbEnum.EditButtonClicked, null, null);
                        scope.context.edit();
                        scope.takeBackup();
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Model.MaintenanceFormState.Readonly,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_PACKAGEMENUCONFIG + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
                {
                    text: 'LABEL_SAVE',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppPackageMenuTab, Model.VerbEnum.SaveButtonClicked, null, null);
                        scope.savePackages();
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Meevo.Model.MaintenanceFormState.Editing,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_PACKAGEMENUCONFIG + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
                {
                    text: 'LABEL_CANCEL',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppPackageMenuTab, Model.VerbEnum.CancelButtonClicked, null, null);
                        this.packages = angular.copy(this.copy);
                        scope.context.setMode(Model.MaintenanceFormState.Readonly);
                        scope.mode = Model.MaintenanceFormState.Readonly;
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Meevo.Model.MaintenanceFormState.Editing,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_PACKAGEMENUCONFIG + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
            ];
        }

        getPackages() {
            var criteria = {
                criteria: {
                    businessType: null,
                    coBusinessTypeId: null,
                    coFilterByLocationId: null,
                    coSearchResultFilter: 0,
                    coSearchType: 0,
                    includeActive: true,
                    includeDeleted: false,
                    includeInactive: false,
                    location: null,
                    maintenanceMode: true,
                },
                itemsPerPage: MAXSAFEINTEGER,
                pageNumber: 0,
                sortBy: null,
                sortDirection: 0
            };

            this.dataService.customMethodData("api/ClientApp/PackageMenuConfig/List", "POST", criteria).then((data) => {
                if (data.data) {
                    this.packages = data.data;
                    this.updatePackagesInfo(null, this.packages);
                    this.copy = angular.copy(this.packages);
                }
            });

            //this.packages = new Meevo.Components.BaseClasses.PagedResults(this.basedataService, "ClientApp/PackageMenuConfig", this.updatePackagesInfo, this);
            //this.packages.initSearch(criteria, null, criteria);
            //this.copy = angular.copy(this.packages.loadedPages);
        }

        updatePackagesInfo = (pageNumber, packages: any): void => {
            if (packages != null) {
                packages.forEach(curr_package => {
                    if (curr_package.hasOverride || !isNaN(curr_package.priceText)) {

                        let currencyFilter = this.$filter('meevoCurrency') as angular.IFilterCurrency;
                        let value = curr_package.priceText.toString().replace('{currency}', '');
                        curr_package.priceText = currencyFilter(value);
                    }
                });
            }
        };

        savePackages() {
            this.busyService.start();
            var packages = { packages: [] };

            var index = 0;
            for (var i = 0; i < this.packages.length; i++) {
                this.packages[i].order = index;
                var currentPackage = angular.copy(this.packages[i]);

                if (currentPackage.isEnabledReverted) {
                    currentPackage.isEnabled = null;
                }

                if (currentPackage.isPriceReverted) {
                    currentPackage.priceText = null;
                }

                if (currentPackage.wasChanged && (currentPackage.isEnabled || (currentPackage.isEnabledReverted && currentPackage.isEnabled_T)) && currentPackage.priceText == "") {
                    this.busyService.stop();
                    return;
                }
                else {
                    packages.packages.push(currentPackage);
                }
                index++;
            }

            this.dataService.customMethodData("api/ClientApp/PackageMenuConfig", "POST", packages).then((data) => {
                this.getPackages();
            }).finally(() => {
                this.mode = Model.MaintenanceFormState.Readonly;
                this.busyService.stop();
            });
        }

        reOrder = (index1: number, index2: number, array: any) => {
            //array = this.packages[index1];
            var array2 = this.packages;
            if (array[index1] && array2[index2]) {
                var temp = array2[index2];
                array2[index2] = array[index1];
                array[index1] = temp;
                array2[index2].order = index2;
                array[index1].order = index1;
            }
        }

        getLastIndexFromPackagesArray() {
            if (this.packages != null)
                return this.packages.length - 1;
            else
                return 0;
        }

        public showRevertEnabledIndicator(packageRow): boolean {
            var showIndicator = false;

            if (packageRow.isEnabled != packageRow.isEnabled_T && !this.context.isApplicationModeCO())
                showIndicator = true;

            return showIndicator;
        }

        public revertToParentEnabled(packageRow): void {
            if (this.mode == Model.MaintenanceFormState.Readonly)
                return;

            packageRow.isEnabled = packageRow.isEnabled_T;
            packageRow.isEnabledReverted = true;
            packageRow.wasChanged = true;
        }

        public showRevertPriceIndicator(packageRow): boolean {
            var showIndicator = false;

            if (this.context.isApplicationModeCO())
                return showIndicator;

            if (packageRow.priceText_L == null && isNaN(packageRow.priceText) && !isNaN(packageRow.priceText_T)) {
                let currencyFilter = this.$filter('meevoCurrency') as angular.IFilterCurrency;
                let value = packageRow.priceText_T.toString().replace('{currency}', '');
                if (packageRow.priceText != currencyFilter(value)) {
                    showIndicator = true;
                }
            }
            else if (packageRow.priceText_L == null && packageRow.priceText != packageRow.priceText_T)
                showIndicator = true;
            else if (packageRow.priceText_L != null && isNaN(packageRow.priceText) && !isNaN(packageRow.priceText_L)) {
                let currencyFilter = this.$filter('meevoCurrency') as angular.IFilterCurrency;
                let value = packageRow.priceText_L.toString().replace('{currency}', '');
                if (packageRow.priceText != currencyFilter(value)) {
                    showIndicator = true;
                }
            }
            else if (packageRow.priceText_L != null && packageRow.priceText != packageRow.priceText_L)
                showIndicator = true;

            return showIndicator;
        }

        public revertToParentPrice(packageRow): void {
            if (this.mode == Model.MaintenanceFormState.Readonly)
                return;

            if (packageRow.priceText_L != null && !isNaN(packageRow.priceText_L)) {
                let currencyFilter = this.$filter('meevoCurrency') as angular.IFilterCurrency;
                let value = packageRow.priceText_L.toString().replace('{currency}', '');
                packageRow.priceText = currencyFilter(value);
            }
            else if (packageRow.priceText_L != null) {
                packageRow.priceText = packageRow.priceText_L;
            }
            else if (!isNaN(packageRow.priceText_T)) {
                let currencyFilter = this.$filter('meevoCurrency') as angular.IFilterCurrency;
                let value = packageRow.priceText_T.toString().replace('{currency}', '');
                packageRow.priceText = currencyFilter(value);
            }
            else
                packageRow.priceText = packageRow.priceText_T;

            packageRow.isPriceReverted = true;
            packageRow.wasChanged = true;
        }

        changePackage(packageRow): void {
            packageRow.wasChanged = true;
        }

    }
}
